<template>
  <Layout>
    <EntitlementPersonLayout />

    <section class="p_main">
        <div class="form-row">
          <div class="col-sm-3 col-md-3 col-lg-3" :key="index" v-for="(document_image, index) in document_images">
            <div class="card">
              <a v-if="document_image.extension == 'jpg' || document_image.extension == 'jpeg' || document_image.extension == 'png'" :href="document_image.name" target="_blank" download>
                <img :src="document_image.name" alt="" class="card-img-top"  height="150"/>
              </a>
              <div class="card-body">
                <p style="margin-bottom: 0px !important;"><strong class="text-dark">Category: </strong>{{ document_image.doc_cat.doc_cat_desc }}</p>
                <p style="margin-bottom: 0px !important;"><strong class="text-dark">Sub Category: </strong>{{ document_image.doc_sub_cat.doc_sub_cat_desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-3 col-md-3 col-lg-3" :key="index" v-for="(document_file, index) in document_files">
            <div class="card">
              <a v-if="document_file.extension == 'pdf'" :href="document_file.name" target="_blank" download>
                <img src="@assets/images/pdf.png" alt="" class="card-img-top"  height="150"/>
              </a>
              <a v-if="document_file.extension == 'docx' || document_file.extension == 'doc'" :href="document_file.name" target="_blank" download>
                <img src="@assets/images/docx.png" alt="" class="card-img-top" height="150"/>
              </a>
              <div class="card-body">
                <p style="margin-bottom: 0px !important;"><strong class="text-dark">Category: </strong>{{ document_file.doc_cat.doc_cat_desc }}</p>
                <p style="margin-bottom: 0px !important;"><strong class="text-dark">Sub Category: </strong>{{ document_file.doc_sub_cat.doc_sub_cat_desc }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white rounded box-shadow p-3" v-if="(document_images.length === 0 && document_files.length === 0) && flag === true">
          <h5 style="text-align: center">No Data Found</h5>
        </div>
    </section>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EntitlementPersonLayout from './layout'
import http from "@state/http";

export default {
  page: {
    title: 'Entitlement Person',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, EntitlementPersonLayout },
  data() {
    return {
      title: 'Entitlement Person file tracking',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Entitlement Person file tracking',
          active: true,
        },
      ],
      document_images: [],
      document_files: [],
      flag: false
    }
  },
  mounted() {
    this.getDocuments();
  },

  methods: {
    getDocuments() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/file-tracking/list/" + ses_id).then(response => {
        if (!response.error) {
          this.flag = true;
          let data = response.data;
          this.document_images = data.document_images;
          this.document_files = data.document_files;
        }
      });
    },
  },
}
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  white-space: nowrap;
}
</style>